import React from 'react';
import './StatusTag.css';

/**
 * Un componente reutilizable para mostrar un tag de estado colorido.
 * @param {object} props
 * @param {string} props.status - El estado del juego (ej: 'game_lobby', 'game_plan').
 */
const StatusTag = ({ status }) => {
  if (!status) return null;

  // Limpiamos el string para usarlo como clase y como texto.
  const cleanStatus = status.value ? status.value.replace('game_', '') : status.replace('game_', '');

  return (
    <span className={`status-tag status-${cleanStatus}`}>
      {cleanStatus}
    </span>
  );
};

export default StatusTag;